import { EventType } from "interfaces";
import { StepsMenu } from "components/shared/event";
import { BuildEventPageStep } from "components/shared/event/sport/steps";

export const CreateWPSSportEvent: React.FC = () => {

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="shrink-0 py-4">
        <StepsMenu eventType={EventType.SPORT} isEdit={false} />
      </div>
      <div className="flex-1 p-4"><BuildEventPageStep /></div>
    </div>
  );
};
